import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/lib/i18n";
import { AuthProvider } from "@/lib/auth";
import PublicLayout from "@/components/site/PublicLayout";
import Home from "@/pages/Home";
import Yachts from "@/pages/Yachts";
import YachtDetail from "@/pages/YachtDetail";
import Tours from "@/pages/Tours";
import Checkout from "@/pages/Checkout";
import Compare from "@/pages/Compare";
import Balance from "@/pages/Balance";
import { CompareProvider } from "@/lib/compare";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminBookings from "@/pages/admin/Bookings";
import AdminYachts from "@/pages/admin/YachtsAdmin";
import AdminCalendar from "@/pages/admin/CalendarAdmin";
import AdminTours from "@/pages/admin/ToursAdmin";
import AdminReviews from "@/pages/admin/ReviewsAdmin";
import AdminDashboard from "@/pages/admin/Dashboard";
import Cashiers from "@/pages/admin/Cashiers";
import PaymentLinks from "@/pages/admin/PaymentLinks";
import EmailSettings from "@/pages/admin/EmailSettings";
import EmailLog from "@/pages/admin/EmailLog";
import PayStatus from "@/pages/PayStatus";
import Legal from "@/pages/Legal";
import PayOrder from "@/pages/PayOrder";
import PurchaseSuccess from "@/pages/PurchaseSuccess";
import GenerateLink from "@/pages/admin/GenerateLink";
import Orders from "@/pages/admin/Orders";
import Confirmations from "@/pages/admin/Confirmations";

export default function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<CompareProvider><PublicLayout /></CompareProvider>}>
            <Route path="/" element={<Home />} />
            <Route path="/yachts" element={<Yachts />} />
            <Route path="/yachts/:id" element={<YachtDetail />} />
            <Route path="/comparar" element={<Compare />} />
            <Route path="/tours" element={<Tours />} />
            <Route path="/checkout/:id" element={<Checkout />} />
            <Route path="/saldo/:id" element={<Balance />} />
            <Route path="/pago/:id" element={<PayStatus />} />
            <Route path="/privacidad" element={<Legal kind="privacy" />} />
            <Route path="/terminos" element={<Legal kind="terms" />} />
          </Route>
          <Route path="/pagar/:orderId" element={<PayOrder />} />
          <Route path="/compra-exitosa" element={<PurchaseSuccess />} />
          <Route path="/admin" element={<AuthProvider><Outlet /></AuthProvider>}>
            <Route path="login" element={<AdminLogin />} />
            <Route element={<AdminLayout />}>
              <Route index element={<Navigate to="/admin/ingresos" replace />} />
              <Route path="ingresos" element={<AdminDashboard />} />
              <Route path="links" element={<PaymentLinks />} />
              <Route path="generar" element={<GenerateLink />} />
              <Route path="pagos" element={<Orders />} />
              <Route path="confirmaciones" element={<Confirmations />} />
              <Route path="cajeros" element={<Cashiers />} />
              <Route path="correos" element={<EmailSettings />} />
              <Route path="envios" element={<EmailLog />} />
              <Route path="bookings" element={<AdminBookings />} />
              <Route path="yachts" element={<AdminYachts />} />
              <Route path="calendar" element={<AdminCalendar />} />
              <Route path="tours" element={<AdminTours />} />
              <Route path="reviews" element={<AdminReviews />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </LangProvider>
  );
}
